import React from "react";
import { Dropdown, Menu, Progress, Typography, Space, Button, Row, Col } from "antd";
import { UserOutlined, CreditCardOutlined, SettingOutlined, LogoutOutlined, CaretUpOutlined } from "@ant-design/icons";
import Avatar from "boring-avatars";
import Meta from "../Meta";
import useAuthStore from "../../states/useAuth";
import useAuth from "../../hooks/useAuth";

const { Text, Title } = Typography;

const AvatarDropdown = ({ isApprover, ...props }) => {
  const { user } = useAuthStore();
  const { signOut } = useAuth();

  const menu = (
    <Menu style={{ width: 300, padding: "16px" }}>
      <div style={{ textAlign: "center", marginBottom: "16px" }}>
        <Avatar size={64} name={user?.name} />
        <Title level={4} style={{ margin: "8px 0 0" }}>
          {user?.name}
        </Title>
        <Text type="secondary">{user?.email}</Text>
      </div>
      <Menu.Item
        key="logout"
        icon={<LogoutOutlined />}
        onClick={() => {
          signOut();
        }}
      >
        <span style={{ fontSize: "1rem" }}>Logout</span>
      </Menu.Item>
    </Menu>
  );

  return (
    <Dropdown overlay={menu} trigger={["click"]} placement="bottomRight">
      <Meta
        className="hover-wrapper"
        style={{ ...props.style }}
        image={<Avatar size={30} name={user?.name} />}
        title={
          <Text
            strong
            style={{
              maxWidth: "7rem", // Set your desired maxWidth
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
            }}
          >
            {user?.name}
          </Text>
        }
        description={isApprover ? "Approver" : "Merchant User"}
      />
    </Dropdown>
  );
};

export default AvatarDropdown;
